import React, { Component, Fragment } from 'react'
import AutoInput from '../containers/AutoInput'
import withValues from '../hocs/withValues'
import { getValue, getBelongsToValue } from '../utils/models'

class TransitForm extends Component {

  render() {
    return (
      <Fragment>
        {
          this.props.belongsTo.association === 'dispatch' &&
          <AutoInput
            form={this.props.form}
            model={'transit'}
            attribute={'dispatch'}
            value={getBelongsToValue('transit', this.props.belongsTo)}
            hidden
          />
        }
        <AutoInput
          form={this.props.form}
          model={'transit'}
          attribute={'date'}
          value={getValue(this.props.values, 'date')}
          mode={'time'}
        />
      </Fragment>
    )
  }

}

export default withValues(TransitForm)



// WEBPACK FOOTER //
// ./src/forms/Transit.js